export const comments_5689023 = {"data":{"data":[],"links":{}}}